import React, { Component } from 'reactn';
import i18n from "../../views/Pages/Login/i18n";
import {
    Col,
    Row,
    Button,
    ButtonDropdown,
    DropdownToggle,
    DropdownMenu,
    DropdownItem,
    Modal,
    ModalHeader,
    ModalBody,
    Input,
    Form,
    FormGroup
} from "reactstrap";
import QueryDataGrid from "../QueryDataGrid/QueryDataGrid";
import TariffOverview from "../TariffOverview/TariffOverview";
import {Mutation, Query, ApolloConsumer} from "react-apollo";
import {
    getQuoteProductNamesQuery,
    getQuotesQuery,
    getQuoteStatusesQuery,
    getQuoteStatusFlowFromQuery,
    setQuoteStatusMutation
} from "../../queries/Queries";
import Loading from "../Loading";
import {Link, withRouter} from "react-router-dom";
import QuoteOverview from "../QuoteOverview";
import PaginatedQueryDataGrid from "../PaginatedQueryDataGrid";



class NoQuotes extends Component {
    constructor(props) {
        super(props)
    }
}
class QuotesGrid extends Component {
    constructor(props) {
        super(props)
        this.state = {
            dropdownOpen: false,
            modalOpen: false,
            reasonModalOpen: false,
            loading: false
        };
        this.toggle = this.toggle.bind(this);
        this.toggleModal = this.toggleModal.bind(this);
        this.toggleReasonModal = this.toggleReasonModal.bind(this);
    }

    toggle() {
        this.setState({
            dropdownOpen: !this.state.dropdownOpen
        });
    }
    toggleModal() {
        this.setState({ modalOpen: !this.state.modalOpen })
    }
    toggleReasonModal(statusToSet, setQuoteStatus, quoteId) {
        this.setState({ reasonModalOpen: !this.state.reasonModalOpen, statusToSet , setQuoteStatus, quoteId})
    }

    render() {
        return (
            <ApolloConsumer>
                {client => <div><Query query={getQuoteProductNamesQuery}>
                    {(resultProductNames) => <Query query={getQuoteStatusesQuery}>
                        {(result) => <Mutation mutation={setQuoteStatusMutation}>
                            {(setQuoteStatus) => (<PaginatedQueryDataGrid dataPath={'getQuotes.content'}
                                                             paginationPath={'getQuotes'}
                                                             keyField={'id'}
                                                             query={getQuotesQuery}
                                                             variables={{
                                                                 organizationId: this.props.organizationId,
                                                                 username: this.props.username
                                                             }}
                                                             filters={[
                                                                 {
                                                                     type: 'text',
                                                                     fields: ['clientName', 'postalCode', 'extraData.products'],
                                                                     placeholder: "Search by client number, name, postal code and meter point",
                                                                     classes: "search",
                                                                     cols: 5
                                                                 },
                                                                 {
                                                                     type: 'dropdown',
                                                                     fields: ['extraData.products'],
                                                                     placeholder: "All Products",
                                                                     possibleValues: resultProductNames.loading ? [] : resultProductNames.data.getQuoteProductNames.map((name) => ({
                                                                         key: name,
                                                                         value: name
                                                                     })),
                                                                     cols: 2
                                                                 },
                                                                 {
                                                                     type: 'dropdown',
                                                                     fields: ['status.name'],
                                                                     placeholder: "All Statuses",
                                                                     possibleValues: result.loading ? [] : result.data.getQuoteStatuses.map(({key, name}) => ({
                                                                         key,
                                                                         value: name
                                                                     })),
                                                                     cols: 2
                                                                 }
                                                             ]}

                                                             columns={[
                                                                 {
                                                                     dataField: 'id',
                                                                     text: i18n.t('quotes.id'),
                                                                     sort: true
                                                                 },
                                                                 {
                                                                     dataField: 'clientName',
                                                                     text: i18n.t('quotes.clientName'),
                                                                     sort: true
                                                                 },
                                                                 {
                                                                     dataField: 'ownerOrganizationName',
                                                                     text: i18n.t('quotes.salesOrganization'),
                                                                     sort: true,

                                                                 },
                                                                 {
                                                                     dataField: 'subOwnerOrganizationName',
                                                                     text: i18n.t('quotes.subSalesOrganization'),
                                                                     sort: true,
                                                                     hidden: !this.global.permissions.includes('Quotes.ViewSubbrokerColumn')
                                                                 },
                                                                 {
                                                                     dataField: 'postalCode',
                                                                     text: i18n.t('quotes.postalCode'),
                                                                     sort: true
                                                                 },
                                                                 {
                                                                     dataField: 'date',
                                                                     text: i18n.t('quotes.date'),
                                                                     sort: true,
                                                                     formatter: (cell, row) => {
                                                                         return new Date(cell.time).toLocaleDateString();
                                                                     }
                                                                 },
                                                                 ...(DYCE
                                                                     ? []
                                                                     : [{
                                                                         dataField: 'tariff',
                                                                         text: i18n.t('quotes.tariffName'),
                                                                         sort: true
                                                                     }])
                                                                 ,
                                                                 {
                                                                     text: i18n.t('quotes.meterPoint'),
                                                                     formatter: (cell, row) => {
                                                                         return row.products.map(e => e.meterPoint).join('\n')
                                                                     }
                                                                 },
                                                                 {
                                                                     text: i18n.t('quotes.productName'),
                                                                     formatter: (cell, row) => {
                                                                         return row.products.map(e => e.name).join('\n')
                                                                     }
                                                                 },
                                                                 {
                                                                     dataField: 'status.name',
                                                                     text: i18n.t('quotes.status'),
                                                                     sort: true
                                                                 },
                                                                 {
                                                                     dataField: 'statusReason',
                                                                     text: i18n.t('quotes.reason'),
                                                                 },
                                                                 {
                                                                     formatter: (cell, row) => {
                                                                         switch (row.status.key) {
                                                                             case "REVISED":
                                                                                 return <a style={{
                                                                                     cursor: "pointer",
                                                                                     fontSize: "150%"
                                                                                 }} color={"primary"}
                                                                                           title={"Create Quote"}
                                                                                           onClick={() => this.props.history.push(`/create-quote/${row.id}`)}>
                                                                                     <i className="icon ion-ios-copy"/>&nbsp;&nbsp;
                                                                                 </a>;
                                                                             case "ACCEPTED":
                                                                                 return <a style={{
                                                                                     cursor: "pointer",
                                                                                     fontSize: "150%"
                                                                                 }} color={"primary"}
                                                                                           title={"Create Contract"}
                                                                                           onClick={() => this.props.history.push(`/create-agreement/${row.processInstanceId}`)}>
                                                                                     <i className="icon ion-android-bookmark"/>&nbsp;&nbsp;
                                                                                 </a>;
                                                                             case "PENDING_PRICING":
                                                                                 return this.global.permissions.includes('Quotes.OpenPendingPricing') ?
                                                                                     <a style={{
                                                                                         cursor: "pointer",
                                                                                         fontSize: "150%"
                                                                                     }} color={"primary"}
                                                                                        title={"Price Quote"}
                                                                                        onClick={() => this.props.history.push(`/price-quote/${row.id}`)}>
                                                                                         <i className="icon ion-pricetags"/>&nbsp;&nbsp;
                                                                                     </a> : null;
                                                                             case "INDUSTRY_CHECK_DONE":
                                                                                 return this.global.permissions.includes('Quotes.OpenIndustryCheckDone') || this.global.username === row.ownerUserId ?
                                                                                     <a style={{
                                                                                         cursor: "pointer",
                                                                                         fontSize: "150%"
                                                                                     }} color={"primary"}
                                                                                        title={"Price Quote"}
                                                                                        onClick={() => this.props.history.push(`/price-quote/${row.id}`)}>
                                                                                         <i className="icon ion-pricetags"/>&nbsp;&nbsp;
                                                                                     </a> : null;
                                                                             default:
                                                                                 return null;
                                                                         }
                                                                     }
                                                                 }

                                                             ]}
                                                             defaultSorted={{
                                                                 dataField: 'date',
                                                                 order: 'desc'
                                                             }}
                            // menuItems={[{name:'Details', callback:(obj) => this.props.history.push('/quotes/'+obj.id)}]}
                                                             menuItems={async(obj) =>  {
                                                                 const { data } = await client.query({
                                                                             query: getQuoteStatusFlowFromQuery,
                                                                             variables: { from: {
                                                                                     key: obj.status.key
                                                                                 }}
                                                                         });

                                                                         return [...data.getQuoteStatusFlowFrom.map(({to}) => ({name: to.name, callback: () => {
                                                                                 if (!to.requireReason) {

                                                                                     return setQuoteStatus({
                                                                                         variables: {
                                                                                             quoteId: obj.id,
                                                                                             quoteStatus: {key: to.key},
                                                                                             statusReason: this.state.statusReason
                                                                                         }
                                                                                     });

                                                                                 } else {
                                                                                     this.toggleReasonModal(to, setQuoteStatus, obj.id);
                                                                                     const promise = new Promise((resolve, reject) =>{
                                                                                         this.setState({statusPromiseResolve : resolve});
                                                                                     });

                                                                                     return promise;
                                                                                 }
                                                                             }})),
                                                                             {name:'Details', callback:(obj) => Promise.resolve(this.props.history.push('/quotes/'+obj.id))}];



                                                                     }

                                                             }
                                                             noDataView={<NoQuotes/>}
                        />)}
                        </Mutation>}
                    </Query>
                    }
                </Query>
                    <Modal isOpen={this.state.reasonModalOpen}
                           toggle={this.toggleReasonModal}
                           className="quote-preview-model">
                        <ModalHeader
                            toggle={this.toggleReasonModal}>
                            Enter reason:
                        </ModalHeader>
                        <ModalBody>
                            <Form>
                                <FormGroup>
                                    <Input type={"select"}
                                           value={this.state.statusReason}
                                           onChange={(e) => this.setState({statusReason: e.target.value})}>
                                        <option></option>
                                        <option
                                            value={"Uncompetitive price"}>Uncompetitive price</option>
                                        <option
                                            value={"Unclear conditions"}>Unclear conditions</option>
                                        <option
                                            value={"Choice of another supplier"}>Chose another supplier</option>
                                        <option
                                            value={"Objection"}>Objection</option>
                                    </Input>
                                </FormGroup>
                            </Form>

                            <Button color='primary'
                                    onClick={() => {
                                        this.state.setQuoteStatus({
                                            variables: {
                                                quoteId: this.state.quoteId,
                                                quoteStatus: this.state.statusToSet, //TODO fix closure  {key: key.to}
                                                statusReason: this.state.statusReason
                                            }
                                        }).then(result => this.state.statusPromiseResolve());
                                        this.toggleReasonModal(null, null, null);
                                        this.setState({statusReason: null});
                                    }}>Submit</Button>

                            <Button color='secondary'
                                    onClick={() => {
                                        this.toggleReasonModal(null,null,null);
                                        this.setState({statusReason: null});
                                    }}>Cancel</Button>
                        </ModalBody>
                    </Modal>
                </div>
                }

            </ApolloConsumer>
        )
    }
}

export default withRouter(QuotesGrid);
